import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import FrontendAlertIcon from "../../..//Icons/FrontendAlertIcon";

function ConfirmDeleteModal({ isOpen = false, onClose, title,lang }) {
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto overflow-x-hidden flex justify-center items-center w-full h-[calc(100%-1rem)] max-h-full"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <div className="relative p-4 w-full max-w-md max-h-full">
          {/* Backdrop */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
          </Transition.Child>

          {/* Modal Panel */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="relative bg-white rounded-lg shadow-sm p-4 md:p-5 text-center">
              {/* Close Button */}
              <button
                type="button"
                className="absolute top-3 right-2.5 text-gray-400 bg-gray-100 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
                onClick={onClose}
              >
                <XMarkIcon className="h-4 w-4" />
                <span className="sr-only">Close modal</span>
              </button>

              <div className="flex flex-col items-center">
                <FrontendAlertIcon className="w-40 h-40 sm:w-40 sm:h-40 md:w-48 md:h-48 lg:w-48 lg:h-48" />

                {/* Title and Message */}
                <div className="mt-3">
                  <h2 className="text-[#E01A1A] text-17 leading-5 font-semibold">
                    {title}
                  </h2>
                  <p className="text-[15px] leading-5 text-[#222222] mt-2">
                    {lang?.kindly_signin_action || 'Kindly Sign-In to complete this action'}
                  </p>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="mt-5 flex items-center justify-center">
                <button
                  type="button"
                  onClick={onClose}
                  ref={cancelButtonRef}
                  className="primary_btn_bg bg-[#0274F7] px-4 py-2 rounded-md text-white text-[15px] leading-[22px] text-left  hover:bg-white hover:text-[#0274F7] border hover:border-[#0274F7]"
                >
                  Close
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default ConfirmDeleteModal;
